<div class="container">
  <div #screenSharing ></div>
</div>
